import {
    Directive,
    ElementRef,
    inject,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';

@Directive({
    selector: '[nwAddAttributes]'
})
export class AddAttributesDirective implements OnChanges {
    @Input('nwAddAttributes') attributes?: Record<string, string>;

    private elementRef: ElementRef = inject(ElementRef);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['attributes'] && this.attributes) {
            Object.entries(this.attributes).forEach(([key, value]) => {
                this.elementRef.nativeElement.setAttribute(key, value);
            });
        }
    }
}
